import { useGreeterGuestApi } from "@greeter/matter";
import { BundlePickerV3, BundlePickerV3Props } from "./BundlePickerV3";

export type BundlePickerSelectorProps = Omit<BundlePickerV3Props, "api">;

export function BundlePickerSelector(props: BundlePickerSelectorProps) {
  const { api } = useGreeterGuestApi();
  return <BundlePickerV3 api={api} {...props} />;
}
